module.exports = __webpack_public_path__ + "img/heading_no.0706a5d2.svg";